import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { ArrowForwardIos } from '@material-ui/icons';

import Button, { ButtonType } from '../Button/Button';

import styles from './ButtonWithArrow.module.scss';

type Props<T extends React.ElementType = 'button'> = ButtonType<T> & {
  component?: T;
  classes?: {
    arrow?: string;
  };
};

function ButtonWithArrow<T extends React.ElementType = 'button'>(
  { children, className, classes, model = 'primary', ...props }: Props<T>,
  ref
): JSX.Element {
  return (
    <Button ref={ref} className={className} model={model} {...props}>
      {children}
      <ArrowForwardIos
        className={classNames(styles.arrow, styles[model], classes?.arrow)}
      />
    </Button>
  );
}

export default forwardRef(ButtonWithArrow);
